<template>
  <div>
    <v-img
      :src="source"
      ref="image"
      :max-width="field.max_width"
      :max-height="field.max_height"
      contain
    />
    <!--    <v-btn @click="deleteImage(index)">Удалить</v-btn>-->
  </div>
</template>

<script>
import config from "../../config";
import { logState } from "../../classes/logging";

export default {
  name: "ImageItem",
  props: ["value", "field", "entity"],
  data() {
    return {
      name: null,
      selectedImage: null
      // updated: false
    };
  },
  mounted() {
    logState("ImageItem.mounted", { color: "blue" }, this.field, this.value);
    this.name = this.value;
  },
  computed: {
    source: {
      get() {
        if (this.name) return this.imagePath();
        if (this.selectedImage) return this.clientPreview();
        return "";
      }
    }
  },
  methods: {
    imagePath() {
      const re = /{([\w\d]+)}/g;
      const url = this.field.url_pattern.replace(re, chunk => {
        const param = chunk.slice(1, -1);
        if (param === "filename") return this.value;
        return this.entity[param];
      });
      logState(
        "Image.imagePath",
        { color: "blue" },
        config.imagesBaseUrl + url
      );
      return config.imagesBaseUrl + url;
    },
    clientPreview() {}
  }
};
</script>
